import * as React from "react"
import {Typography} from '@mui/material'
import {IconSeeker, TooltipSeeker} from "@ui-seeker/core"
import {formatPercentage} from "@ui-seeker/utils"


export default function diffColumn() {
	return {
		name: 'diff',
		label: 'Diff (%)',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { previous }) => <TooltipSeeker title={`Previous: ${previous || '-'}`}>
				<Typography sx={{ fontSize: '0.875rem', textAlign: 'center', color: !!value ? value > 0 ? 'green' : 'red' : 'default' }}>
					{ !!value && <IconSeeker icon={`arrow-${value > 0 ? 'up' : 'down'}`} sx={{ mr: 0.5 }} /> }
					{ value !== null && !!previous ? formatPercentage(value) : '-' }
				</Typography>
			</TooltipSeeker>
		}
	}
}